import React from "react";
import Select from "react-select";

const RSelect = React.forwardRef(({ options = [], invalid, disabled, ...props }, ref) => {

  const parsedOptions = options.map((item) => {
    // if already formatted, return as is
    if (item.label && item.value) return item;

    // convert API format automatically
    if (item.name && item.id !== undefined) {
      return {
        value: item.id,
        label: item.name,
        ...item, // keep other fields like code, nibssCode
      };
    }

    return item;
  });

  return (
    <div
      className="form-control-select"
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.7 : 1,
        border: invalid ? "1px solid red" : undefined,
      }}
    >
      <Select
        ref={ref}
        className={`react-select-container ${props.className ? props.className : ""}`}
        classNamePrefix="react-select"
        options={parsedOptions}
        isDisabled={disabled}
        {...props}
      />
    </div>
  );
});

export default RSelect;